/**
 * Coralino Beachwear - Advanced Cyber-Shield & Anti-Bot Armor
 * Protocolo de Seguridad y Protección de Propiedad Intelectual
 * 
 * Capacidades:
 * 1. Detección y mitigación de Headless Browsers (Puppeteer, Playwright, Selenium, Webdriver).
 * 2. Protección activa Anti-Scraping de Catálogo e Imágenes de Alta Resolución.
 * 3. Bloqueo de atajos de inspección y robo de código fuente (F12, Ctrl+U, Ctrl+Shift+I/C/J).
 * 4. Escudo Anti-Clickjacking y Framebusting para evitar clonación en iframes.
 * 5. Inyección dinámica de trampas Honeypot en formularios para neutralizar spam bots.
 */

(function() {
  'use strict';

  // 0. EXENCIÓN TOTAL PARA EL EDITOR DE TEMAS DE SHOPIFY
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.location.search.indexOf('preview_theme_id') !== -1) return;
    if (window.top !== window.self) {
      // Si está incrustado en Shopify Admin/Editor de temas, deshabilitar escudo para permitir previsualización
      return;
    }
  } catch (err) {
    return;
  }

  // 2. CENTINELA EN CONSOLA (LEGAL & SECURITY BANNER)
  var bannerStyle = 'background: #1C1716; color: #FA806E; font-size: 13px; font-weight: bold; padding: 8px 14px; border-radius: 6px; border: 1px solid #FA806E;';
  var textStyle = 'color: #7A6962; font-size: 11px; font-family: sans-serif;';
  
  if (window.console && window.console.log) {
    console.log('%c🛡️ CORALINO CYBER-SHIELD · SISTEMA DE SEGURIDAD ACTIVO', bannerStyle);
    console.log('%cTodos los accesos, peticiones y activos están protegidos por derechos de autor y monitoreo de integridad. Queda prohibida la extracción automatizada, scraping o clonación no autorizada de catálogo.', textStyle);
  }

  // 3. DETECTOR DE SCRAPERS AUTOMATIZADOS Y HEADLESS BROWSERS
  function detectHeadlessAutomation() {
    var isBot = false;

    // A. Indicador estándar W3C Webdriver
    if (navigator.webdriver) {
      isBot = true;
    }

    // B. Indicadores de automatización conocidos (Selenium, PhantomJS, Nightmare)
    if (window.callPhantom || window._phantom || window.__nightmare || window._selenium || window.domAutomation) {
      isBot = true;
    }

    // C. Indicadores de Chrome DevTools Protocol / Puppeteer
    if (/HeadlessChrome/.test(navigator.userAgent)) {
      isBot = true;
    }

    // D. Inconsistencia de Plugins / Lenguajes en Headless
    if (navigator.plugins && navigator.plugins.length === 0 && !/Mobile|Android|iPhone/i.test(navigator.userAgent)) {
      // Sospecha de entorno emulado sin plugins estándar
    }

    if (isBot) {
      // Neutralizar comportamiento del scraper
      window.addEventListener('load', function() {
        var sensitiveCards = document.querySelectorAll('.c-product-card-item, .c-panoramic-banner-img, .coral-products-grid');
        sensitiveCards.forEach(function(el) {
          el.setAttribute('data-protected', 'shield-active');
        });
      });
    }
  }

  detectHeadlessAutomation();

  // 4. NOTIFICACIÓN TOAST DISCRETA DE PROTECCIÓN DE CONTENIDO
  var toastTimer = null;
  function showSecurityNotice(msg) {
    var existingToast = document.getElementById('cSecurityShieldToast');
    if (!existingToast) {
      existingToast = document.createElement('div');
      existingToast.id = 'cSecurityShieldToast';
      existingToast.style.cssText = [
        'position: fixed',
        'bottom: 24px',
        'left: 50%',
        'transform: translateX(-50%) translateY(20px)',
        'background: rgba(28, 23, 22, 0.94)',
        'color: #FAF5EF',
        'padding: 12px 24px',
        'border-radius: 9999px',
        'border: 1px solid rgba(250, 128, 110, 0.5)',
        'font-family: Montserrat, sans-serif',
        'font-size: 0.8rem',
        'font-weight: 600',
        'letter-spacing: 0.04em',
        'box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35)',
        'z-index: 10000000',
        'pointer-events: none',
        'opacity: 0',
        'transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
        'display: flex',
        'align-items: center',
        'gap: 10px',
        'white-space: nowrap'
      ].join(';');
      document.body.appendChild(existingToast);
    }

    existingToast.innerHTML = '<span style="color:#FA806E;font-size:1rem;">✦</span> ' + (msg || 'Propiedad Intelectual y Catálogo Protegidos · Coralino Beachwear');
    existingToast.style.opacity = '1';
    existingToast.style.transform = 'translateX(-50%) translateY(0)';

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      existingToast.style.opacity = '0';
      existingToast.style.transform = 'translateX(-50%) translateY(20px)';
    }, 2400);
  }

  // 5. PROTECCIÓN ANTI-SCRAPING: BLOQUEO DE CLIC DERECHO EN IMÁGENES Y CATÁLOGO
  document.addEventListener('contextmenu', function(e) {
    var target = e.target;
    var isSensitive = target.tagName === 'IMG' || 
                      target.closest('img') || 
                      target.closest('.c-product-card-item') || 
                      target.closest('.c-collection-hero-fullwidth') ||
                      target.closest('.c-policy-hero-banner') ||
                      target.closest('.coral-products-grid') ||
                      target.closest('.coralino-catalog-layout');

    if (isSensitive) {
      e.preventDefault();
      showSecurityNotice('Imágenes y Siluetas Protegidas © Coralino Atelier');
      return false;
    }
  }, { passive: false });

  // 6. PROTECCIÓN CONTRA ARRASTRE DE IMÁGENES (DRAG & DROP DOWNLOAD)
  document.addEventListener('dragstart', function(e) {
    if (e.target.tagName === 'IMG' || e.target.closest('img')) {
      e.preventDefault();
      return false;
    }
  }, { passive: false });

  // 7. BLOQUEO DE ATAJOS DE INSPECCIÓN Y VOLCADO DE CÓDIGO
  document.addEventListener('keydown', function(e) {
    var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    var ctrlKey = isMac ? e.metaKey : e.ctrlKey;

    // F12 -> DevTools
    if (e.keyCode === 123 || e.key === 'F12') {
      e.preventDefault();
      showSecurityNotice('Acceso a herramientas de desarrollador restringido');
      return false;
    }

    // Ctrl+Shift+I / Cmd+Option+I (Inspector)
    if (ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i' || e.keyCode === 73)) {
      e.preventDefault();
      showSecurityNotice('Inspector de elementos restringido');
      return false;
    }

    // Ctrl+Shift+J / Cmd+Option+J (Consola)
    if (ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j' || e.keyCode === 74)) {
      e.preventDefault();
      return false;
    }

    // Ctrl+Shift+C / Cmd+Option+C (Selector de Elementos)
    if (ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c' || e.keyCode === 67)) {
      e.preventDefault();
      return false;
    }

    // Ctrl+U / Cmd+Option+U (Ver Código Fuente)
    if (ctrlKey && (e.key === 'u' || e.key === 'U' || e.keyCode === 85)) {
      e.preventDefault();
      showSecurityNotice('Descarga de código fuente deshabilitada');
      return false;
    }

    // Ctrl+S / Cmd+S (Guardar Página Completa)
    if (ctrlKey && (e.key === 's' || e.key === 'S' || e.keyCode === 83)) {
      e.preventDefault();
      showSecurityNotice('Guardado local protegido');
      return false;
    }
  }, { passive: false });

  // 8. TRAMPA HONEYPOT DINÁMICA EN FORMULARIOS Y VERIFICACIÓN TIME-TO-SUBMIT
  var pageLoadTime = Date.now();

  function armFormsWithSecurityShield() {
    var forms = document.querySelectorAll('form');
    forms.forEach(function(form) {
      if (!form.querySelector('.c-hp-security-trap')) {
        var trap = document.createElement('input');
        trap.type = 'text';
        trap.name = 'coralino_security_honeypot_field';
        trap.className = 'c-hp-security-trap';
        trap.tabIndex = -1;
        trap.autocomplete = 'off';
        trap.style.cssText = 'position:absolute!important;left:-9999px!important;opacity:0!important;height:0!important;width:0!important;pointer-events:none!important;';
        trap.setAttribute('aria-hidden', 'true');
        form.appendChild(trap);
      }

      form.addEventListener('submit', function(ev) {
        var hp = form.querySelector('.c-hp-security-trap');
        if (hp && hp.value !== '') {
          // El bot llenó el campo señuelo -> Abortar
          ev.preventDefault();
          ev.stopPropagation();
          return false;
        }

        // Detección de velocidad no humana (menos de 800ms)
        var elapsed = Date.now() - pageLoadTime;
        if (elapsed < 800 && !form.classList.contains('c-allow-fast-submit')) {
          ev.preventDefault();
          ev.stopPropagation();
          return false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armFormsWithSecurityShield);
  } else {
    armFormsWithSecurityShield();
  }

})();
